import React, { Component } from 'react';
import axios from '../../shared/axios/axios';
import newAxios from '../../shared/axios/new-api-axios';
import { connect } from 'react-redux';
import { hot } from 'react-hot-loader/root';

import { reverseMappingTypes } from '../../shared/constants/enums';

import { isGuid } from '../../shared/utils';

import withErrorHandler from '../../hoc/withErrorHandler';

import EditReverseMapping from './edit-reverse-mapping';
import FillReverseMapping from './fill-reverse-mapping';
import FilledReverseMapping from './filled-reverse-mapping';

import './styles.less';

let root;

class ReverseMappingComponent extends Component {
  render() {
    const { rootContainer, formId, reverseMappingType, redirectUrl, userId, agencyId } = this.props;

    let reverseMapping = null;

    switch (reverseMappingType) {
      case reverseMappingTypes.Edit:
        reverseMapping = <EditReverseMapping rootContainer={rootContainer} formId={formId} redirectUrl={redirectUrl} isNewForm={!isGuid(formId)} />;
        break;

      case reverseMappingTypes.Fill:
        reverseMapping = (
          <FillReverseMapping rootContainer={rootContainer} formId={formId} redirectUrl={redirectUrl} userId={userId} agencyId={agencyId} />
        );
        break;

      case reverseMappingTypes.Filled:
        reverseMapping = <FilledReverseMapping rootContainer={rootContainer} formId={formId} redirectUrl={redirectUrl} />;
        break;
    }

    return <div className="reverse-mapping-div">{reverseMapping}</div>;
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(hot(withErrorHandler(ReverseMappingComponent, axios, root, newAxios)));
